module.exports = __webpack_public_path__ + "static/media/grade3-I__bg-completed.00ca214c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/xRay/grade3-I__bg-completed.png
// module id = 2368
// module chunks = 0